import {
  Autocomplete,
  AutocompleteItem,
  Button,
} from "@nextui-org/react"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
  VirtualizeAutoComplete,
} from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_ACTYPE, ENUM_APP_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModValue, linksUrl } from "../../constants/enum"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useSelector } from "react-redux"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { useEffect, useMemo, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { calculateTotal } from "../../Utility/utility"
import { isMobile } from "react-device-detect"
import { useNavigate } from "react-router-dom"


const SalesOrderSummary = () => {
  let { compCode, appType } = useSelector((state) => state.company)
  let [selectedParty, setSelectedParty] = useState("")
  let [selectedItemType, setSelectedItemType] = useState("GRAY")
  let [selectedProduct, setSelectedProduct] = useState("")
  const filterItemType = [{ item_type: "GRAY" }, { item_type: "SUITE" }]
  //let [data, setData] = useState([])
  const [menuTrigger, setMenuTrigger] = useState("input");
  const inputRef = useRef(null)
  const navi = useNavigate()
  const [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  })

  const { isLoading, isError: isErrorFetch, data: itemDetails = [] } = useFetchWithBody({
    url: apiRoute.salesorder.fetchMasterData,
    queryKey: "SalesMasterData",
    inputData: {
      compcode: compCode[0],//.join(","),
    }
  })

  const {
    isPending,
    isError,
    data = [],
    //data: salesOrderData = [],
    mutate: filterSales,
  } = usePost({
    url: apiRoute.salesorder.fetch,
    queryKey: "SalesOrder",
  })
  const funSalesData = () => {
    filterSales({
      data: {
        compcode: compCode.join(","),
        fromdate: filterDate.start
          ? new Date(filterDate.start).toISOString().split("T")[0]
          : null,
        todate: filterDate.end
          ? new Date(filterDate.end).toISOString().split("T")[0]
          : null,

        partyname: selectedParty != null && selectedParty !== "" ? selectedParty : "",
        itemcode: selectedProduct != null && selectedProduct !== "" ? selectedProduct : "", //"F/13261",
        action: selectedItemType !== "" ? selectedItemType : "", // "GRAY",
      },
    })
  }

  // useEffect(() => {
  //   setData(salesOrderData)
  // }, [salesOrderData])

  useEffect(() => {

    funSalesData()
  }, [])

  // const handleDataChange = ({ data, isFilter }) => {

  //   if (isFilter)
  //     setData(data)
  //   else{

  //     setData(salesOrderData)
  //   }
  // }
  const handleWrapperMouseDown = (e) => {
    const isClearButton = e.target.closest("[aria-label='Clear']");
    if (isClearButton) {

      return; // Let clear button work normally
    }
    const iconClicked = e.target.closest("[aria-label='Open menu']");
    if (iconClicked) {
      setMenuTrigger("manual");
    } else {
      setMenuTrigger("input");
    }
  };
  const handleOpenChange = (isOpen, trigger) => {
    // if (isOpen && trigger === "manual") {
    //     // Find the input inside the autocomplete
    //     const input = inputRef.current?.querySelector("input");
    //     input?.blur(); // ✅ Close keyboard
    // }
    if (isOpen && trigger === "manual") {
      // User clicked icon → close keyboard
      inputRef.current?.blur();
    }

  };

  let totalOrdQty = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "OMETER",
      }),
    [data]
  )
  let totalDelQty = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "dmeter",
      }),
    [data]
  )

  let totalBalQty = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "BMETER",
      }),
    [data]
  )
  let downloadDataFooter = {
    party: "",

    item_code: "",
    item_desc: "",
    order_no: "",
    order_date: "",
    qtyper: "",
    OMETER: "Total: " + totalOrdQty,
    RATE: "",
    dmeter: "Total: " + totalDelQty,
    BMETER: "Total: " + totalBalQty,
    broker: "",
    remark: "",
  }


  const handleResetFilter = () => {
    setSelectedParty("") //{ key: "", value: "" }
    setSelectedItemType("GRAY")
    setSelectedProduct("") //{ key: "", value: "" }
    setFilterDate({
      start: null,
      end: null,
    })
    /// funSalesData()
    filterSales({
      data: {
        compcode: compCode.join(","),
        fromdate: null,
        todate: null,
        partyname: "",
        itemcode: "", //"F/13261",
        action: "GRAY",
      },
    })
  }

  const handleFilter = () => {
    funSalesData()
  }


  const INITIAL_VISIBLE_COLUMNS = [
    "party",
    "item_code",
    "item_desc",
    "order_no",
    "order_date",
    "qtyper",
    "OMETER",
    "RATE",
    "dmeter",
    "BMETER",
    "broker",
    "remark",
  ]
  const columns = [
    { name: "PARTY NAME", uid: "party", sortable: true },

    {
      name: "ITEM CODE",
      uid: "item_code",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },

    {
      name: "ITEM DESC",
      uid: "item_desc",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "ORDER NO.",
      uid: "order_no",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ORDER DATE",
      uid: "order_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "QTY TYPE",
      uid: "qtyper",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "ORD.QTY",
      uid: "OMETER",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalOrdQty,
      },
    },
    {
      name: "RATE",
      uid: "RATE",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "DEL.QTY",
      uid: "dmeter",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalDelQty,
      },
    },
    {
      name: "BAL.QTY",
      uid: "BMETER",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalQty,
      },
    },
    {
      name: "Broker",
      uid: "broker",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },
    {
      name: "REMARK",
      uid: "remark",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]
  if (isPending) { return <LoadingCard /> }
  if (isError || isErrorFetch) { return <ErrorCard /> }
  return (
    <div>

      <MainContainer
        pageName="Sales Order Summary"
        info={[]}
        breadcrumbs={["Reports & View ", "Summary"]}
      >

        <div className="flex flex-wrap mb-2 bg-gray-10 gap-2 shadow p-3">

          {/* date */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={"Start Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.start
                  ? dayjs(filterDate.start)
                  : filterDate.start
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              sx={{ width: "145px" }}
              slotProps={{ textField: { size: "small" } }}
            />
            <DatePicker
              label={"End Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.end ? dayjs(filterDate.end) : filterDate.end
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              slotProps={{ textField: { size: "small" } }}
              sx={{ width: "145px" }}
            />
          </LocalizationProvider>

          <div className={` flex  items-center gap-2 ${isMobile ? "flex-wrap" : ""} `} >
            <div onMouseDown={handleWrapperMouseDown}>
              <Autocomplete
                size="sm"
                name={"itemCode"}
                label={"Item Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className={`${isMobile ? "w-full" : "max-w-42"} `}
                isClearable={true}
                variant="bordered"
                menuTrigger={menuTrigger}
                isVirtualized
                defaultItems={
                  itemDetails && itemDetails.itemMaster
                    ? itemDetails.itemMaster : []
                }
                onOpenChange={handleOpenChange}
                ref={inputRef}
                onSelectionChange={setSelectedProduct}
                selectedKey={selectedProduct}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Item_Code}
                  >
                    {list.Item_CodeNDesc}
                  </AutocompleteItem>
                )}
              </Autocomplete>
            </div>
            <Autocomplete
              size="sm"
              name={"partyId"}
              label={"Party Name"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className={`${isMobile ? "w-full" : "max-w-42"} `}
              isClearable={true}
              variant="bordered"
              isVirtualized
              defaultItems={
                itemDetails && itemDetails.pitemMaster
                  ? itemDetails.pitemMaster : []
              }
              onSelectionChange={setSelectedParty}
              selectedKey={selectedParty}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Party_Id}
                >
                  {list.Party_Name}
                </AutocompleteItem>
              )}
            </Autocomplete>
          </div>
          <Autocomplete
            size="sm"
            label="Item Type"
            className="max-w-36"
            defaultItems={filterItemType ? filterItemType : []}
            selectedKey={selectedItemType}
            onSelectionChange={setSelectedItemType}
          >
            {(item) => (
              <AutocompleteItem key={item.item_type}>
                {item.item_type}
              </AutocompleteItem>
            )}
          </Autocomplete>

          <Button
            color="primary"
            size="sm"
            startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            onPress={handleFilter}

          >
            Search
          </Button>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faFilter} />}
            onPress={handleResetFilter}
          >
            Reset
          </Button>

        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          // handleDataChange={handleDataChange}
          columns={columns}
          exportColumns={columns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="SALES_ORDER"
          showAdvanceFilter={false}
          id="Item_Code"
        ></NextUITable>

      </MainContainer>
    </div>
  )
}
export default SalesOrderSummary


{/* <Autocomplete
              
size="sm"
label="Item Name"
className="max-w-40"
defaultItems={
  itemDetails && itemDetails.itemMaster
    ? itemDetails.itemMaster
    : []
}
onSelectionChange={setSelectedProduct}
selectedKey={selectedProduct}
>
{(item) => (
  <AutocompleteItem key={item.Item_Code}>
   {item.Item_CodeNDesc}
  </AutocompleteItem>
)}
</Autocomplete>

<Autocomplete
size="sm"
label="Party Name"
className="max-w-36"
defaultItems={
  itemDetails && itemDetails.pitemMaster
    ? itemDetails.pitemMaster
    : []
}
selectedKey={selectedParty}
onSelectionChange={setSelectedParty}
>
{(item) => (
  <AutocompleteItem key={item.Party_Id}>
    {item.Party_Name}
  </AutocompleteItem>
)}
</Autocomplete> */}